var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.9375C2.25 5.53968 2.40804 5.15814 2.68934 4.87684C2.97064 4.59554 3.35218 4.4375 3.75 4.4375H14.25C14.6478 4.4375 15.0294 4.59554 15.3107 4.87684C15.592 5.15814 15.75 5.53968 15.75 5.9375V13.4375C15.75 13.8353 15.592 14.2169 15.3107 14.4982C15.0294 14.7795 14.6478 14.9375 14.25 14.9375H3.75C3.35218 14.9375 2.97064 14.7795 2.68934 14.4982C2.40804 14.2169 2.25 13.8353 2.25 13.4375V5.9375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.9375L9 10.4375L15.75 5.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.686523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3840a7286b4d41a096f25db9da7a67ac.svg";
export { ForwardRef as ReactComponent };